export default __webpack_public_path__ + "static/media/mascots_success.fcb1cf71.svg";